import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

const StarProgressIcon = (props) => (
  <Svg width={40} height={40} viewBox="0 0 40 40" fill="none">
    <Circle
      cx={20}
      cy={20}
      r={20}
      fill={props?.color ? props.color : "#D9D9D9"}
    />
    <Path
      d="M28.9344 19.6304L25.8204 22.6226L26.5554 26.8435C26.6754 27.5325 26.3974 28.2195 25.8294 28.6355C25.2504 29.0585 24.4944 29.1166 23.8564 28.7876L20.0004 26.7905L16.1444 28.7876C15.8704 28.9296 15.5734 28.9995 15.2784 28.9995C14.8884 28.9995 14.5014 28.8765 14.1714 28.6355C13.6044 28.2195 13.3254 27.5325 13.4454 26.8435L14.1804 22.6226L11.0664 19.6304C10.5564 19.1404 10.3734 18.4195 10.5894 17.7495C10.8074 17.0715 11.3854 16.5886 12.0974 16.4866L16.4064 15.8694L18.3324 12.0244C18.6484 11.3924 19.2884 11.0005 20.0004 11.0005C20.7124 11.0005 21.3524 11.3934 21.6684 12.0244L23.5944 15.8694L27.9034 16.4866C28.6144 16.5886 29.1924 17.0715 29.4104 17.7495C29.6264 18.4195 29.4444 19.1404 28.9344 19.6304Z"
      fill={props?.innerColor ? props.innerColor : "#808080"}
    />
  </Svg>
);

export default StarProgressIcon;
